import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from '../../../common/Flex';

const ProfileActivityLog = ({ user }) => {
  // Datos simulados de actividad reciente - en el futuro esto vendría del API
  const recentActivity = [
    {
      id: 1,
      type: 'login',
      description: 'Inicio de sesión',
      timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000), // 2 horas atrás
      icon: 'sign-in-alt',
      variant: 'success'
    },
    {
      id: 2,
      type: 'profile_update',
      description: 'Perfil actualizado',
      timestamp: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000), // 1 día atrás
      icon: 'user-edit',
      variant: 'info'
    },
    {
      id: 3,
      type: 'budget_view',
      description: 'Consultó presupuestos',
      timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000), // 2 días atrás
      icon: 'chart-line',
      variant: 'primary'
    },
    {
      id: 4,
      type: 'campaign_create',
      description: 'Creó nueva campaña',
      timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000), // 3 días atrás
      icon: 'plus-circle',
      variant: 'warning'
    },
    {
      id: 5,
      type: 'settings_change',
      description: 'Cambió configuraciones',
      timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 días atrás
      icon: 'cog',
      variant: 'secondary'
    }
  ];

  const formatRelativeTime = (timestamp) => {
    const now = new Date();
    const diff = now - timestamp;
    const minutes = Math.floor(diff / (1000 * 60));
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (minutes < 60) {
      return `Hace ${minutes} min`;
    } else if (hours < 24) {
      return `Hace ${hours}h`;
    } else {
      return `Hace ${days}d`;
    }
  };

  const getActivityIcon = (type) => {
    const iconMap = {
      login: 'sign-in-alt',
      logout: 'sign-out-alt',
      profile_update: 'user-edit',
      budget_view: 'chart-line',
      campaign_create: 'plus-circle',
      campaign_edit: 'edit',
      settings_change: 'cog',
      report_download: 'download',
      data_export: 'file-export'
    };
    return iconMap[type] || 'circle';
  };

  const getActivityVariant = (type) => {
    const variantMap = {
      login: 'success',
      logout: 'danger',
      profile_update: 'info',
      budget_view: 'primary',
      campaign_create: 'warning',
      campaign_edit: 'info',
      settings_change: 'secondary',
      report_download: 'success',
      data_export: 'primary'
    };
    return variantMap[type] || 'light';
  };

  return (
    <Card className="mb-3">
      <Card.Header className="bg-body-tertiary">
        <h6 className="mb-0">
          <FontAwesomeIcon icon="history" className="me-2" />
          Actividad Reciente
        </h6>
      </Card.Header>
      <Card.Body className="p-0">
        {recentActivity.length > 0 ? (
          <div className="timeline">
            {recentActivity.map((activity, index) => (
              <div key={activity.id} className="timeline-item border-bottom p-3">
                <Flex alignItems="start">
                  <div className="me-3">
                    <div 
                      className={`rounded-circle d-flex align-items-center justify-content-center bg-${getActivityVariant(activity.type)} bg-opacity-10`}
                      style={{ width: '32px', height: '32px' }}
                    >
                      <FontAwesomeIcon 
                        icon={getActivityIcon(activity.type)} 
                        className={`fs-10 text-${getActivityVariant(activity.type)}`}
                      />
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <h6 className="mb-1 fs-10">{activity.description}</h6>
                        <small className="text-muted fs-11">
                          {formatRelativeTime(activity.timestamp)}
                        </small>
                      </div>
                      <Badge 
                        bg={getActivityVariant(activity.type)} 
                        className="fs-11"
                        style={{ fontSize: '0.7rem' }}
                      >
                        {activity.type.replace('_', ' ')}
                      </Badge>
                    </div>
                  </div>
                </Flex>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-4">
            <FontAwesomeIcon icon="clock" className="text-muted fs-1 mb-2" />
            <p className="text-muted mb-0">No hay actividad reciente</p>
          </div>
        )}
      </Card.Body>
      <Card.Footer className="bg-body-tertiary text-center py-2">
        <small className="text-muted">
          <FontAwesomeIcon icon="info-circle" className="me-1" />
          Últimas 5 actividades
        </small>
      </Card.Footer>
    </Card>
  );
};

export default ProfileActivityLog; 